import * as React from "react";

import Heading from "./Heading";

const OptimizedCompute = () => (
  <>
    <Heading
      title="Optimized compute for BUSINESS context"
      subtitle="End-to-End Optimization for Speed and Efficiency"
    />
    <div className="flex flex-wrap -mx-2">
      <div className="lg:w-1/2 px-2 lg:pr-16 mb-6 lg:mb-0">
        <div className="flex">
          <h2 className="text-3xl font-semibold text-brand-600">
            Business data isnt classical Machine Learning data.
          </h2>
        </div>
      </div>
      <div className="lg:w-1/2 px-2">
        <p className="pb-4">
          While data can be large, it is often very wide but shallow. For
          example businesses want to analyze weekly sales data, and that by
          definition has only 52 data-points in a year. But, there typically are
          thousands of such time-series.
        </p>
        <p className="pb-4">
          Many kinds of data also tends to be time-series, e.g, SCADA/sensors,
          sales, etc., while one also sees transaction/event level data which
          lends itself to profiling, clustering, etc.
        </p>
        <p className="pb-4">
          Our algorithms are geared towards EXACTLY these kinds of data - they
          figure out the data types automatically, and analyze them accordingly.
          All with MINIMAL USER INPUT.
        </p>
      </div>
    </div>
    <div className="flex flex-wrap -mx-2 mt-2">
      <div className="lg:w-1/2 px-2 lg:pr-16 mb-6 lg:mb-0">
        <div className="flex">
          <h2 className="text-3xl font-semibold text-brand-600">
            Feature Engineering with the right amount of abstraction,
            computational robustness and speed.
          </h2>
        </div>
      </div>
      <div className="lg:w-1/2 px-2">
        <p className="pb-4">
          There are a large number of hypotheses which are mathematically
          similar. We managed to extract the similarities to be able to build
          them all. Consider MTBF in manufacturing, and frequency in retail.
          While the two of them seem and mean very different things,
          mathematically they are exactly the same.
        </p>
        <p className="pb-4">
          However, its easy to abstract at the wrong level. Take the example of
          churn. Churn in e-commerce needs to be treated very differently from
          churn in a SaaS context.
        </p>
        <p className="pb-4">
          Our feature engineering strikes the correct balance, and is also
          designed to ensure robustness. All this while being wicked fast.
        </p>
      </div>
    </div>
    <div className="flex flex-wrap -mx-2 mt-2">
      <div className="lg:w-1/2 px-2 lg:pr-16 mb-6 lg:mb-0">
        <div className="flex">
          <h2 className="text-3xl font-semibold text-brand-600">
            Mathematically Correct and Fast Algorithms over "cool" algorithms
            anyday.
          </h2>
        </div>
      </div>
      <div className="lg:w-1/2 px-2">
        <p className="pb-4">
          We are fanatical over mathematical correctness and speed: All our
          algorithm choices are driven by these two factors.
        </p>
        <p className="pb-4">
          Daisho knows which algorithm to apply in which context - the decision
          is driven by mathematical correctness. We then optimized these
          algorithms so that the results are wicked fast. As an example, Daisho
          is able to analyse 50,000 + individual time-series is less than 5
          minutes!
        </p>
      </div>
    </div>
    {/* <div className="flex flex-wrap -mx-2 mt-2">
      <div className="lg:w-1/2 px-2 lg:pr-16 mb-6 lg:mb-0">
        <div className="flex">
          <h2 className="text-3xl font-semibold text-brand-600">
            Business Actionability needs business insights. Not mathematical
            models.
          </h2>
        </div>
      </div>
      <div className="lg:w-1/2 px-2">
        <p className="pb-4">
          Daisho automatically translates all the math into insights that are
          understandable and actionable by business users. We provide a wide
          variety of interactive visualizations and simulations to make insights
          understandable.
        </p>
        <p className="pb-4">
          Insights cannot stop at model building - models need to be acted
          constantly. Hence Daisho's provides robust tools to do predictions as
          well as to keep the models and features updated.
        </p>
      </div>
    </div> */}
  </>
);

export default OptimizedCompute;
